export enum ButtonType {
  icon = 'icon',
  iconwithcheckmark = 'iconwithcheckmark',
  text = 'text',
  textwithicon = 'textwithicon',
}
